<template>
    <div id="app">
        <div class="page">
            <header>
                <div class="brand">
                    <div class="container">
                        <img src="https://e-dziennik.mein.gov.pl/app/themes/vue/static/img/logo.ea38667.svg" height="100" alt="Godło Polski">
                        <h1>Dziennik Urzędowy <br/>{{ title }}</h1>
                    </div>
                </div>
                <div class="navigation">
                    <div class="container">

                        <b-navbar toggleable="md">

                            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

                            <b-collapse is-nav id="nav_collapse">

                                <b-navbar-nav>
                                    <router-link tag="li" to="/" tabindex=1 class="nav-item"><a class="nav-link" >Strona główna</a></router-link>
                                    <router-link tag="li" to="/page/certyfikaty" tabindex=2 class="nav-item"><a class="nav-link">Certyfikaty</a></router-link>
                                    <router-link tag="li" to="/page/pomoc" tabindex=3 class="nav-item"><a class="nav-link">Pomoc</a></router-link>
<!--                                    <router-link tag="li" to="/page/informacje" tabindex=3 class="nav-item"><a class="nav-link">Informacje</a></router-link>-->
<!--                                  <li tabindex=4 class="nav-item">-->
<!--                                    <a class="nav-link" href="https://e-dziennik.men.gov.pl"  target="_blank">Archiwum MEN</a>-->
<!--                                  </li>-->
<!--                                  <li tabindex=5 class="nav-item">-->
<!--                                    <a class="nav-link" href="https://www.gov.pl/web/edukacja-i-nauka/nauka-i-szkolnictwo-wyzsze4"  target="_blank">Archiwum MNiSW</a>-->
<!--                                  </li>-->
                                </b-navbar-nav>

                                <b-navbar-nav class="ml-auto">
                                  <router-link tag="li" to="/page/deklaracja-dostepnosci-serwisu" tabindex=6 class="nav-item">
                                    <a>Deklaracja dostępności</a>
                                  </router-link>
                                  <li tabindex=7 class="nav-item">
                                    <a class="nav-link" href="https://www.gov.pl/web/edukacja"  >www.gov.pl</a>
                                  </li>
                                </b-navbar-nav>

                            </b-collapse>
                        </b-navbar>


                    </div>

                </div>

            </header>
            <main>
                <b-container>
                    <router-view/>
                </b-container>
            </main>

        </div>


    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            title: 'Ministra Edukacji Narodowej',
            initValue: 10,
            inProgress: false
        };
    },
    methods: {
        toggleState(value) {
            this.inProgress = value;
        }
    },
    created() {
        //this.$events.$on("progress", this.toggleState);
    },
    components: {
        //Counter
    }
}
</script>

<style>
    body    { overflow-y:scroll; }
    body a{color: #006adb;}
    .btn-secondary:focus, .btn-secondary.focus,.btn-secondary:hover, .btn-secondary.hover {
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      /*border: 1px dashed #006adb;*/
    }
    .form-control:focus, .form-control:hover{
      /*border: 1px dashed #006adb;*/
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
    }
    :root{
      --white: #fae6fa;
    }
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .router-link-exact-active a {
        background-color: #EEE;
        border-radius: 6px;
      /*-webkit-box-shadow: 0 0 0 0.1rem rgba(0, 0, 0, 1);*/
      /*box-shadow: 0 0 0 0.1rem rgba(0, 0, 0, 1);*/
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      /*border: 1px dashed black;*/
    }
    .form-control:focus, .form-control:focus {
      /*border: 1px dashed black;*/
      outline: 0;
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
    }
    .custom-select:focus {
      outline: 0;
      /*border: 1px dashed black;*/
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      outline: #0a246a;
    }
    .navigation .men-url {
        color: #fff;
    }
    .men-url:focus {
      /*border: 1px dashed #D64000;*/
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
    }

    div.navigation {
        margin: 0 0 20px 0;
        display: block;
        border-top: 1px solid #EEE;
        border-bottom: 1px solid #EEE;
    }
    .navigation .container {
        padding: 0 0;
    }
    .navigation {
        list-style: none;
        padding: 0px 0;
        margin: 0 0;
    }
    .navigation li {
        display: inline-block;

    }
    .navigation li a {
        text-decoration: none;
        color: #666;
        display: block;
        padding: 10px 20px;
    }
    :focus{
      -webkit-box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      box-shadow: 0 0 0 0.1rem rgba(0, 106, 219, 1);
      outline: #0a246a;
    }
    .navigation li a:hover{
      text-decoration: underline;
    }

    .navigation li:first-child a {

    }

    .brand {
        background-color: #18599e;
        padding: 20px;
        color: #FFF;
    }
    .brand img { float: left; }
    .brand h1 {
        display: inline-block;
        width: 360px;
        font-size: 1.6rem;
        margin: 0 0 0 20px;
        line-height: 1.2;
        padding: 15px 0;
    }

    table {
        border: 0;
        padding: 0;
        margin: 0;
        border-collapse: collapse;
        width: 100%
    }

    table td {
        border: 1px solid #EEE; padding: 5px 10px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue